import {types} from './types';

const initialState = {
    list_jackpot: []
}

export function jackpotMobileReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_JACKPOT:
            return { ...state, list_jackpot: action.payload};
        default:
            return state
    }
}